module.exports = __webpack_public_path__ + "img/applyhelp@2x.356afaa9.png";